import SyncListBatchMoveModal from './SyncListBatchActionModal'

export default SyncListBatchMoveModal
